import React, {Fragment, PureComponent} from 'react';

// import type {PeriodValueType} from '../date-picker';
// import Button from '../button';
// import Icon from '../icon';
// import FormGroup from '../form-group';
// import DatePickerInput from '../date-picker-input';
// import DatePickerInputRange from '../date-picker-input-range';


import {IntlProvider} from 'react-intl';
import {Button, Icon, FormGroup, DatePickerInput, DatePickerInputRange} from 'xsolla-uikit';


type State = {
  single: ?Date,
  range: PeriodValueType
};

type PeriodValueType = {
  from: ?Date,
  to: ?Date
};






class DatePickerExample extends PureComponent<null, State> {

  constructor(props) {
    super(props);
    this.state = {
      single: props.date || null,
      range: {
        from: null,
        to: null
      }
    }
  }

  render(props) {
    return (
      //
        <Fragment>


        {/* <FormGroup label="Single input" indentation="sm">
          <DatePickerInput
            name="single"
            input={{
              value: this.state.single,
              onChange: day => this.setState({single: day})
            }}
            size="sm"
          />
        </FormGroup> */}

        {/* <FormGroup label="Single input (with time)">
          <DatePickerInput
            name="single"
            input={{
              value: this.state.single,
              onChange: day => this.setState({single: day})
            }}
            size="sm"
            pickTime={true}
          />
        </FormGroup> */}

        <FormGroup label={props ? props.title : null}>
          <DatePickerInput
            name="single"
            input={{
              value: this.state.single,
              onChange: day => this.setState({single: day})
            }}
            size="sm"
            pickTime={true}
            timePickerProps={{disabledMinutes: true}}
          />
        </FormGroup>

        {/* <FormGroup label="Single input (custom input)">
          <DatePickerInput
            name="single"
            input={{
              value: this.state.single,
              onChange: day => this.setState({single: day})
            }}
            customInput={({size, placeholder, disabled, focused, onClick, raw}) => (
              <Button
                appearance="flatten"
                size={size}
                disabled={disabled}
                focused={focused}
                onClick={onClick}>
                <Icon name="calendar" /> {(raw && new Date(raw).toDateString()) || placeholder}
              </Button>
            )}
          />
        </FormGroup> */}

        {/* <FormGroup label="Range input (with presets)" indentation="sm">
          <DatePickerInputRange
            name="range"
            input={{
              value: this.state.range,
              onChange: range => this.setState({range: range})
            }}
            size="sm"
            visiblePresets={true}
            visibleClearButton={true}
          />
        </FormGroup> */}

        {/* <FormGroup label="Range input (1 month)">
          <DatePickerInputRange
            name="range"
            input={{
              value: this.state.range,
              onChange: range => this.setState({range: range})
            }}
            numberOfMonths={1}
            size="sm"
          />
        </FormGroup> */}

        {/* <FormGroup label="Disabled">
          <DatePickerInput
            name="single"
            input={{
              value: this.state.single,
              onChange: day => this.setState({single: day})
            }}
            size="sm"
            disabled={true}
          />
        </FormGroup> */}


      </Fragment>
      //
    );
  }
}

export default DatePickerExample;
